// Latest Firefly glow, published by the dock and read by the bell in docked mode.
import { useSyncExternalStore } from "react";
import type { KpiTone } from "@/components/common/kpi/kpiTypes";

export type AttentionChromeSnapshot = {
  tone: KpiTone | null;
  summary: string;
  reasonLabel: string | null;
  panelOpen: boolean;
};

const EMPTY: AttentionChromeSnapshot = {
  tone: null,
  summary: "",
  reasonLabel: null,
  panelOpen: false,
};

let current: AttentionChromeSnapshot = EMPTY;
const listeners = new Set<() => void>();

export function publishAttentionChrome(next: AttentionChromeSnapshot): void {
  current = next;
  for (const listener of listeners) listener();
}

export function getAttentionChrome(): AttentionChromeSnapshot {
  return current;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useAttentionChrome(): AttentionChromeSnapshot {
  return useSyncExternalStore(subscribe, getAttentionChrome, () => EMPTY);
}
